import React from 'react';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Skeleton from '@material-ui/lab/Skeleton';
import ProductLineSkeleton from '@afosto/app-components-react/ProductLine/ProductLineSkeleton';
import QuantityBoxSkeleton from '@afosto/app-components-react/QuantityBox/QuantityBoxSkeleton';

const PackingItemSkeleton = () => (
  <Grid item xs={12}>
    <Card>
      <Box display="flex" flexWrap="nowrap" alignItems="center">
        <CardContent>
          <Skeleton height={24} width={24} variant="rect" />
        </CardContent>
        <Box display="flex" flexGrow={1} alignItems="center">
          <Box flex={1} p={1} pt={2}>
            <ProductLineSkeleton />
          </Box>
          <Hidden smDown implementation="js">
            <Box p={1}>
              <QuantityBoxSkeleton />
            </Box>
          </Hidden>
        </Box>
      </Box>
    </Card>
  </Grid>
);

export default PackingItemSkeleton;
